import { AlpineComponent } from 'alpinejs';

const ImageComponent = (): AlpineComponent => ({
  init() {
    const SELECTOR_FULLSCREEN_BTN = document.querySelectorAll('button[data-js-fullscreen]');
    const CLASS_SECTION_IMG_WRAPPER = '.section__image-wrapper';
    const CLASS_FULLSCREEN = 'fullscreen';

    if (!SELECTOR_FULLSCREEN_BTN) return;

    function deactivateFullscreen() {

      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    };

    SELECTOR_FULLSCREEN_BTN.forEach(el => {
      const SELECTOR_IMG = el.closest(CLASS_SECTION_IMG_WRAPPER).querySelector('img');

      el.addEventListener('click', () => {
        // const SELECTOR_IMG = el.closest(CLASS_SECTION_IMG_WRAPPER).querySelector('img');

        if (SELECTOR_IMG.fullscreenElement) { 
          SELECTOR_IMG.exitFullscreen();
        }
        else if (SELECTOR_IMG.webkitRequestFullscreen) { // Safari
          SELECTOR_IMG.classList.add(CLASS_FULLSCREEN);
          SELECTOR_IMG.webkitRequestFullscreen();
        }
        else if (SELECTOR_IMG.mozRequestFullScreen) {
          SELECTOR_IMG.classList.add(CLASS_FULLSCREEN);
          SELECTOR_IMG.mozRequestFullScreen(); // Firefox
        }
        else { 
          // SELECTOR_IMG.classList.add(CLASS_FULLSCREEN);
          // SELECTOR_IMG.requestFullscreen();

          window.open(SELECTOR_IMG.src, '_blank').focus();
        } 
      });
    });

    document.onclick = () => {
      if (document.fullscreenElement) {
        deactivateFullscreen();
      };
    };
  }
});

export default ImageComponent;
